var map = {
	"./Ascot.less": "2e9c",
	"./EnergySolutions.less": "457a",
	"./OceanVolt.less": "8a95",
	"./OffgridEnergy.less": "c167",
	"./Powercore.less": "fa07",
	"./PureDriveEnergy.less": "4046",
	"./SOEnergy.less": "be75",
	"./Smartflower.less": "c202",
	"./TryStar.less": "7a1f",
	"./UNDP.less": "319e",
	"./ecube.less": "4899"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e7cb";